import React from "react";
import scrollTo from "gatsby-plugin-smoothscroll";

/**
 * Function to handle click on a letter.
 * Scrolls to the element with the given id.
 * @param {string} id - The id of the element to scroll to.
 */
const handleLetterClick = (id) => {
    scrollTo(`#${id}`);
};

/**
 * InnerPageNavigationVertical component.
 * Renders a vertical navigation menu with clickable items.
 * @param {Object} props - The component props.
 * @param {Object} props.data - The data for the navigation menu.
 * @returns {JSX.Element} The rendered component.
 */
const InnerPageNavigationVertical = ({ data }) => {
    const { title, cardItem, customId } = data ?? {};

    return (
        <section id={customId}>
            <div className="container">
                <div className="inner-nav-wrapper md:max-w-80">
                    {title && <h2 className="text-sm text-blue font-w font-normal">{title}</h2>}
                    {/* Render the navigation items if they exist */}
                    {cardItem?.cta?.length > 0 && (
                        <ul className="inner-nav list-none items-start mt-7.5 pb-5 border-t border-stone block">
                            {cardItem?.cta?.map((ctaItem) => (
                                <li
                                    key={ctaItem.id}
                                    className={`card-id${ctaItem.id} navitem mt-7.5 after:hidden p-0 pl-5 first:mt-0`}
                                >
                                    <a
                                        href={`#${ctaItem.externalUrl}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            // Handle click on navigation item
                                            handleLetterClick(ctaItem.externalUrl);
                                        }}
                                        className="block p-0 grey-link  text-center text-base font-semibold pr-3.5 leading-tight"
                                    >
                                        {ctaItem.text}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </section>
    );
};

export default InnerPageNavigationVertical;
